module.exports = __webpack_public_path__ + "static/media/Zayan.fc139bd7.png";